// React
import React, { useRef, useEffect } from 'react';

// Components
import MissionTitle from '../components/MissionTitle';

// Data
import { contentData } from '../assets/data/contentData';

// GSAP
import gsap from 'gsap';

// Contexts
import { useTimer } from '../contextes/useTimer';
import { useSound } from '../contextes/SoundContext';
import MissionTitleTutoriel from '../components/MissionTitleTutoriel';

const Menu: React.FC = () => {
    // 1. Créer une référence pour l'élément DOM
    const logoFBIRef = useRef<HTMLDivElement>(null);
    const logoMSDRef = useRef<HTMLDivElement>(null);
    const { resetTimer } = useTimer();
    const { stopSound } = useSound();

    useEffect(() => {
        stopSound();
        resetTimer();
        if (logoFBIRef.current) {
            // 2. Définir l'état initial (depuis le milieu en y, avec scale 2)
            gsap.set(logoFBIRef.current, { scale: 2, y: '35vh' });

            // 3. Animer vers l'état final (position normale, visible)
            gsap.to(logoFBIRef.current, {
                scale: 1,
                delay: 1,
                y: 0,
                duration: 2,
                ease: 'power3.out',
            });
        }
        if (logoMSDRef.current) {
            // 2. Définir l'état initial (depuis le bas, invisible)
            gsap.set(logoMSDRef.current, { y: '-20vh' });

            // 3. Animer vers l'état final (position normale, visible)
            gsap.to(logoMSDRef.current, {
                y: 0,
                delay: 1,
                duration: 2,
                ease: 'power3.out',
            });
        }
    }, []);

    return (
        <div className='menu-container'>
            <div ref={logoFBIRef}>
                <img
                    src='./images/logo-intro.png'
                    alt='Logo'
                    className='menu-logo'
                />
            </div>
            <div className='menu-items'>
                {contentData.missions.map((item, index) => {
                    if (index === 0) {
                        return (
                            <MissionTitleTutoriel
                                key={index}
                                title={item.title}
                                missionNumber={0}
                            />
                        );
                    }
                    return (
                        <MissionTitle
                            key={item.id}
                            title={item.title}
                            missionNumber={item.id}
                        />
                    );
                })}
            </div>
            <div ref={logoMSDRef}>
                <img
                    src='./images/logo-msd.png'
                    alt='Logo MSD'
                    className='menu-logo-msd'
                />
            </div>
        </div>
    );
};

export default Menu;
